import React from "react";
import { motion } from "framer-motion";

import img1 from "../images/portfolio/1.jpg";
import img2 from "../images/portfolio/2.jpg";
import img3 from "../images/portfolio/3.jpg";
import img4 from "../images/portfolio/4.jpg";
import img5 from "../images/portfolio/5.jpg";
import img6 from "../images/portfolio/6.jpg";
import img7 from "../images/portfolio/7.jpg";
import img8 from "../images/portfolio/8.jpg";
import img9 from "../images/portfolio/9.jpg";
import img10 from "../images/portfolio/10.jpg";
import img11 from "../images/portfolio/11.jpg";
import img12 from "../images/portfolio/12.jpg";
import img14 from "../images/portfolio/14.jpg";
import img15 from "../images/portfolio/15.jpg";
import img16 from "../images/portfolio/16.jpg";
import img17 from "../images/portfolio/17.jpg";
import img18 from "../images/portfolio/18.jpg";
import img19 from "../images/portfolio/19.jpg";
import img20 from "../images/portfolio/20.jpg";
import img22 from "../images/portfolio/22.jpg";


const photos = [
  img15,img3,img8,img12,img5,img19,img2,
  img16,img9,img22,img7,img14,img1,
  img10,img6,img18,img4,img20,img17, img11
];

const item = {
  hidden: { opacity: 0, y: 30 },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.45
    }
  }
};

const container = {
  hidden: {},
  show: {
    transition: {
      staggerChildren: 0.06
    }
  }
};

const Portfolio: React.FC = () => {

  return (
    <div className="bg-[#f5f3ef] text-[#1a1a1a]">

      {/* HEADER */}

      <section className="max-w-6xl mx-auto px-10 pt-32 pb-20 text-center">

        <p className="text-sm text-neutral-500 mb-4">
          Portfolio
        </p>

        <h1 className="text-5xl md:text-6xl font-light mb-6">
          Des visuels authentiques
          <br />
          pour raconter ton univers
        </h1>

        <p className="text-neutral-600 max-w-2xl mx-auto">
          Une sélection de projets réalisés pour des marques
          et entrepreneuses souhaitant valoriser leur identité
          et leur présence sur les réseaux.
        </p>

      </section>


      {/* GRID */}

      <section className="max-w-7xl mx-auto px-6 pb-28">

        <motion.div
          variants={container}
          initial="hidden"
          animate="show"
          className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4"
        >

          {photos.map((src, index) => (

            <motion.div
              key={index}
              variants={item}
              className="group relative overflow-hidden rounded-xl cursor-pointer"
            >

              {/* IMAGE */}

              <motion.img
                src={src}
                alt={`photo-${index}`}
                loading="lazy"
                className="w-full h-full object-cover transition duration-700 group-hover:scale-110 will-change-transform"
              />

              {/* OVERLAY */}

              <div className="absolute inset-0 bg-black/10 opacity-0 group-hover:opacity-100 transition duration-500"/>

              {/* LIGHT EFFECT */}

              <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition duration-700 bg-gradient-to-t from-black/40 via-transparent to-transparent"/>

            </motion.div>

          ))}

        </motion.div>

      </section>


      {/* CTA */}

      <section className="text-center py-28 px-10">

        <h2 className="text-4xl font-light mb-6">
          Créons quelque chose de beau
        </h2>

        <p className="text-neutral-600 mb-8">
          Parlons de ton projet et imaginons
          ensemble les visuels de ton univers.
        </p>

        <a
          href="/contact"
          className="inline-block bg-gradient-to-r from-gray-900 to-black text-white px-8 py-4 rounded-full shadow-lg transition hover:scale-105"
        >
          Discuter de mon projet
        </a>

      </section>

    </div>
  );
};

export default Portfolio;
